"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6727,1917],{

/***/ 68019:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ Img; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(68777);
/* harmony import */ var react_lazy_load_image_component_src_effects_blur_css__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(68893);
/* harmony import */ var react_lazy_load_image_component_src_effects_blur_css__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react_lazy_load_image_component_src_effects_blur_css__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);





var Img = function Img(_ref) {
  var nolazy = _ref.nolazy,
      visible = _ref.visible,
      srcSm = _ref.srcSm,
      src = _ref.src,
      position = _ref.position,
      objectFit = _ref.objectFit,
      height = _ref.height,
      width = _ref.width,
      banner = _ref.banner,
      alt = _ref.alt,
      left = _ref.left,
      margin = _ref.margin,
      right = _ref.right,
      top = _ref.top,
      bottom = _ref.bottom;
  var DefaultBanner = '/images/static/blurbg.svg';

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(0),
      deviceWidth = _useState[0],
      setDeviceWidth = _useState[1]; // set device width


  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    function HandleWidth() {
      setDeviceWidth(window.innerWidth);
    }

    window.addEventListener('resize', HandleWidth);
    HandleWidth();
    return function () {
      window.removeEventListener('resize', HandleWidth);
    };
  });
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(StyledImg, {
    className: "global-image",
    srcSm: srcSm,
    objectFit: objectFit,
    margin: margin,
    position: position,
    left: left,
    right: right,
    top: top,
    bottom: bottom,
    height: height,
    width: width,
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
      quality: 100,
      priority: true,
      blurDataURL: "".concat(DefaultBanner),
      alt: alt || 'Shanta Securities Limited',
      objectFit: 'cover',
      layout: 'fill',
      src: src ? deviceWidth > 600 ? src : srcSm ? srcSm : src : DefaultBanner // use normal <img> attributes as props

    })
  });
};
var StyledImg = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "Img__StyledImg",
  componentId: "sc-1091rec-0"
})(["position:", ";height:", ";width:", ";top:", ";left:", ";bottom:", ";right:", ";margin:", ";img{width:100%;height:100%;object-fit:", ";position:absolute;top:0;left:0;right:0;bottom:0;}"], function (props) {
  return props.position || 'absolute';
}, function (props) {
  return props.height || '100%';
}, function (props) {
  return props.width || '100%';
}, function (props) {
  return props.top || 0;
}, function (props) {
  return props.left || 0;
}, function (props) {
  return props.bottom || 0;
}, function (props) {
  return props.right || 0;
}, function (props) {
  return props.margin || 0;
}, function (props) {
  return props.objectFit || 'cover';
});

/***/ }),

/***/ 49982:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(10682);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(21608);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(31555);
/* harmony import */ var _styles_globalStyleVars__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(68312);
/* harmony import */ var gsap__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(62642);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react_html_parser__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(30653);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(68777);
/* harmony import */ var _Img__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(68019);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(85893);








 // import Button from "../ButtonOpenNow";
// import ButtonB from "../ButtonBrochure";



var Button = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function () {
  return __webpack_require__.e(/* import() */ 265).then(__webpack_require__.bind(__webpack_require__, 70265));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(70265)];
    }
  }
});
var ButtonB = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function () {
  return __webpack_require__.e(/* import() */ 6435).then(__webpack_require__.bind(__webpack_require__, 46435));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(46435)];
    }
  }
});

var LubeSolution = function LubeSolution(_ref) {
  var _data$section_data, _data$section_data2, _data$section_data3, _data$images, _data$images$list, _data$images$list$, _data$section_data4, _data$section_data5, _data$section_data6, _data$posts, _data$images2, _data$images2$list;

  var padding = _ref.padding,
      data = _ref.data,
      title = _ref.title,
      subtitle = _ref.subtitle,
      text = _ref.text,
      brochure = _ref.brochure,
      bigtitle = _ref.bigtitle,
      image = _ref.image,
      link = _ref.link,
      winWidth = _ref.winWidth,
      offsetContainer = _ref.offsetContainer,
      offset = _ref.offset;
  text = data === null || data === void 0 ? void 0 : (_data$section_data = data.section_data) === null || _data$section_data === void 0 ? void 0 : _data$section_data.description;
  title = data === null || data === void 0 ? void 0 : (_data$section_data2 = data.section_data) === null || _data$section_data2 === void 0 ? void 0 : _data$section_data2.subtitle;
  subtitle = data === null || data === void 0 ? void 0 : (_data$section_data3 = data.section_data) === null || _data$section_data3 === void 0 ? void 0 : _data$section_data3.short_desc;
  image = data === null || data === void 0 ? void 0 : (_data$images = data.images) === null || _data$images === void 0 ? void 0 : (_data$images$list = _data$images.list) === null || _data$images$list === void 0 ? void 0 : (_data$images$list$ = _data$images$list[0]) === null || _data$images$list$ === void 0 ? void 0 : _data$images$list$.full_path;
  link = data === null || data === void 0 ? void 0 : (_data$section_data4 = data.section_data) === null || _data$section_data4 === void 0 ? void 0 : _data$section_data4.extra_field;
  var brochure_link = data === null || data === void 0 ? void 0 : (_data$section_data5 = data.section_data) === null || _data$section_data5 === void 0 ? void 0 : _data$section_data5.brochure;
  var top_description = data === null || data === void 0 ? void 0 : (_data$section_data6 = data.section_data) === null || _data$section_data6 === void 0 ? void 0 : _data$section_data6.top_description;
  var banner = null;
  var thumb = null;
  var thumbBottom = null;
  var thumbDark = null;
  var thumbDarkDesktop = null;
  var postList = null;
  postList = data === null || data === void 0 ? void 0 : (_data$posts = data.posts) === null || _data$posts === void 0 ? void 0 : _data$posts.list;
  data === null || data === void 0 ? void 0 : (_data$images2 = data.images) === null || _data$images2 === void 0 ? void 0 : (_data$images2$list = _data$images2.list) === null || _data$images2$list === void 0 ? void 0 : _data$images2$list.map(function (e) {
    if ((e === null || e === void 0 ? void 0 : e.banner) === "on") {
      banner = e === null || e === void 0 ? void 0 : e.full_path;
    } else if ((e === null || e === void 0 ? void 0 : e.background) === "on") {
      thumbBottom = e === null || e === void 0 ? void 0 : e.full_path;
    } else if ((e === null || e === void 0 ? void 0 : e.thumb) === "on") {
      thumb = e === null || e === void 0 ? void 0 : e.full_path;
    } else if ((e === null || e === void 0 ? void 0 : e.is_dark) === "on") {
      thumbDark = e === null || e === void 0 ? void 0 : e.full_path;
    } else if ((e === null || e === void 0 ? void 0 : e.is_dark_desktop) === "on") {
      thumbDarkDesktop = e === null || e === void 0 ? void 0 : e.full_path;
    }
  });
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    var handleResize = function handleResize() {
      if (window.innerWidth > 767) {
        var containerOffsetLeft = document.querySelector(".container").offsetLeft;
        var lubeTestingImgBox = document.querySelector(".lube-testing__img__box");
        var lubeTestingImgBox2 = document.querySelector(".lube-testing__text");
        var marginLeft = containerOffsetLeft + 15;
        lubeTestingImgBox.style.setProperty("left", "".concat(offsetContainer + 15, "px"));
        lubeTestingImgBox2.style.setProperty("padding-right", "".concat(marginLeft, "px"));
      }
    };

    handleResize(); // Initial positioning

    window.addEventListener("resize", handleResize);
    return function () {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  var location = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    // Use GSAP to animate opacity from 0 to 1
    gsap__WEBPACK_IMPORTED_MODULE_6__/* .gsap.to */ .p8.to(".hide", {
      alpha: 1,
      visibility: "visible",
      display: "block",
      duration: 0.5,
      delay: 1
    });
  }, [location.pathname]); // Run this effect only once when the component mounts

  console.log(postList, "data?.section_data");
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)(StyledLubeSolution, {
    offset: offset,
    className: "lube-testing  ".concat(padding ? padding : " pt-200"),
    children: [bigtitle ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
          className: "bigtitle",
          md: 12,
          children: top_description && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("h3", {
            className: "split-up",
            children: (0,react_html_parser__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(top_description)
          })
        })
      })
    }) : "", /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
      fluid: true,
      className: "p-0",
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)(react_bootstrap__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)(react_bootstrap__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
          sm: 5,
          className: "lube-testing__img",
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("div", {
            className: "lube-testing__img__inner ",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("div", {
              className: "",
              children: banner ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_Img__WEBPACK_IMPORTED_MODULE_4__/* .Img */ .E, {
                alt: "Shanta Securities Limited",
                src: banner ? banner : "/images/static/blur.jpg"
              }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_Img__WEBPACK_IMPORTED_MODULE_4__/* .Img */ .E, {
                alt: "Shanta Securities Limited",
                src: image ? image : "/images/static/blur.jpg"
              })
            })
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("div", {
            className: "lube-testing__img__box",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)("div", {
              className: "lube-testing__img__box__inner box ",
              children: [title ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("h5", {
                className: "split-up",
                children: title ? (0,react_html_parser__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(title) : "An organization dedicated to securing your future"
              }) : "", brochure ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(ButtonB, {
                src: brochure_link ? brochure_link : "https://portal.shantasecurities.com/signup",
                text: "Open an Account Now",
                margin: "30px 0 0 0",
                background: "transparent",
                color: "#fff",
                icon: true,
                borderColor: "#000"
              }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(Button, {
                target: "_blank",
                link: link,
                text: "Open an Account Now",
                margin: "30px 0 0 0",
                background: "transparent",
                color: "#fff",
                icon: true
              })]
            })
          })]
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)(react_bootstrap__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
          sm: 7,
          "data-lag": "0.1",
          className: "lube-testing__text",
          children: [subtitle ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("h5", {
            className: "split-up",
            children: subtitle ? subtitle : "Investing in finance allows you to diversify your portfolio. Putting all your money in a single asset or keeping it in cash can be risky. By diversifying your investments, you can reduce the impact of any one investment's performance on your overall portfolio."
          }) : "", text ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("p", {
            className: "split-up",
            children: (0,react_html_parser__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(text)
          }) : "", winWidth > 767 ? thumbBottom ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("img", {
            alt: "Shanta Securities Limited",
            className: "new_img",
            src: thumbBottom ? thumbBottom : "/images/static/blur.jpg"
          }) : "" : "", /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("div", {
            className: "d-flex shanta-all-brand-list",
            children: postList && postList.length > 0 && postList.map(function (item, index) {
              var _item$images, _item$images2, _item$data, _item$data2, _item$data3;

              var darkImg = item === null || item === void 0 ? void 0 : (_item$images = item.images) === null || _item$images === void 0 ? void 0 : _item$images.find(function (f) {
                return (f === null || f === void 0 ? void 0 : f.background) === "on";
              });
              var lightImg = item === null || item === void 0 ? void 0 : (_item$images2 = item.images) === null || _item$images2 === void 0 ? void 0 : _item$images2.find(function (f) {
                return (f === null || f === void 0 ? void 0 : f.is_dark) === "on";
              });
              return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)("a", {
                style: {
                  display: "inline-block",
                  height: "100px"
                },
                href: (_item$data = item.data) === null || _item$data === void 0 ? void 0 : _item$data.subtitle,
                target: "_blank",
                children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("img", {
                  alt: (_item$data2 = item.data) === null || _item$data2 === void 0 ? void 0 : _item$data2.title,
                  className: "image-light-theme",
                  src: lightImg ? lightImg === null || lightImg === void 0 ? void 0 : lightImg.full_path : "/images/static/blur.jpg"
                }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("img", {
                  alt: (_item$data3 = item.data) === null || _item$data3 === void 0 ? void 0 : _item$data3.title,
                  className: "image-dark-theme",
                  src: darkImg ? darkImg === null || darkImg === void 0 ? void 0 : darkImg.full_path : "/images/static/blur.jpg"
                })]
              }, index);
            })
          })]
        })]
      })
    })]
  });
};

var StyledLubeSolution = styled_components__WEBPACK_IMPORTED_MODULE_10__/* ["default"].section.withConfig */ .ZP.section.withConfig({
  displayName: "Invest__StyledLubeSolution",
  componentId: "sc-hgsax5-0"
})(["background-color:#ffffff;margin-bottom:-25px;@media (max-width:767px){overflow:hidden;}.new_img,.dark_image,.dark_image_deskotp{margin-top:40px;}.dark_image,.dark_image_deskotp{display:none;}.lube-testing__img__box{padding-left:", ";}@media (max-width:767px){.dark_image_deskotp{display:none;}.lube-testing__img__box{padding-left:unset;}}.bigtitle{font-size:32px;font-weight:500;line-height:44px;color:#3c3c3b;font-family:", ";margin-bottom:75px;span{color:", ";}}.lube-testing__img{position:relative;top:-25px;padding-right:55px;&__inner{padding-top:calc(420 / 528 * 100%);position:relative;min-height:100%;}.reveal{height:100%;}&__box{position:absolute;bottom:-75px;&__inner{height:216px;width:335px;position:relative;background-color:#978c21;z-index:222;h5{font-size:20px;line-height:28px;color:#ffffff;font-weight:500;position:absolute;top:30px;left:30px;right:30px;display:-webkit-box;-webkit-line-clamp:4;-webkit-box-orient:vertical;white-space:normal;overflow:hidden;}}.dc-btn{position:absolute;bottom:30px;left:30px;}}}.lube-testing__text{justify-content:flex-start;display:flex;flex-direction:column;h5{font-size:24px;line-height:28px;font-weight:500;margin-bottom:40px;color:#3c3c3b;font-family:", ";}p{font-size:16px;line-height:24px;font-weight:500;margin-bottom:0;color:#3c3c3b;span{color:", ";}&:nth-last-child(1){margin-bottom:0;}}}@media (max-width:991px){.lube-testing__img{padding-right:0;}.lube-testing__text{padding-left:75px;}.lube-testing__img__box{&__inner{}}}@media (min-width:768px) and (max-width:1150px){.lube-testing__img__box{&__inner h2{font-size:22px;line-height:26px;}}}@media (max-width:767px){padding-bottom:0;margin-bottom:-25px;.row{flex-direction:column-reverse;}.col-sm-5,.col-sm-6{min-width:100%;margin:0;}.lube-testing__img{padding-right:0 !important;margin-top:60px;}.lube-testing__img__box{left:0 !important;position:relative;right:0 !important;bottom:0 !important;&__inner{width:100% !important;h5{font-size:20px;line-height:24px;}}}.lube-testing__text{padding:0 30px !important;margin-top:0;}}"], function (props) {
  return props.offset ? props.offset + "px" : "";
}, _styles_globalStyleVars__WEBPACK_IMPORTED_MODULE_11__/* .title */ .TN, _styles_globalStyleVars__WEBPACK_IMPORTED_MODULE_11__/* .hover */ .Mr, _styles_globalStyleVars__WEBPACK_IMPORTED_MODULE_11__/* .title */ .TN, _styles_globalStyleVars__WEBPACK_IMPORTED_MODULE_11__/* .hover */ .Mr);
/* harmony default export */ __webpack_exports__["default"] = (/*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.memo(LubeSolution));

/***/ })

}]);